"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Editor plugin event type
 */
var PluginEventType;
(function (PluginEventType) {
    /**
     * HTML KeyDown event
     */
    PluginEventType[PluginEventType["KeyDown"] = 0] = "KeyDown";
    /**
     * HTML KeyPress event
     */
    PluginEventType[PluginEventType["KeyPress"] = 1] = "KeyPress";
    /**
     * HTML KeyUp event
     */
    PluginEventType[PluginEventType["KeyUp"] = 2] = "KeyUp";
    /**
     * HTML CompositionEnd event
     */
    PluginEventType[PluginEventType["CompositionEnd"] = 3] = "CompositionEnd";
    /**
     * HTML MouseDown event
     */
    PluginEventType[PluginEventType["MouseDown"] = 4] = "MouseDown";
    /**
     * HTML MouseUp event
     */
    PluginEventType[PluginEventType["MouseUp"] = 5] = "MouseUp";
    /**
     * Content changed event
     */
    PluginEventType[PluginEventType["ContentChanged"] = 6] = "ContentChanged";
    /**
     * @deprecated Use ExtractContentWithDom instead.
     * Extract Content event
     * This event is triggered when getContent() is called with triggerExtractContentEvent = true
     * Plugin can handle this event to remove the UI only markups to return clean HTML
     */
    PluginEventType[PluginEventType["ExtractContent"] = 7] = "ExtractContent";
    /**
     * Extract Content with a DOM tree event
     * This event is triggered when getContent() is called with triggerExtractContentEvent = true
     * Plugin can handle this event to remove the UI only markups to return clean HTML
     * by operating on a cloned DOM tree
     */
    PluginEventType[PluginEventType["ExtractContentWithDom"] = 8] = "ExtractContentWithDom";
    /**
     * Before Paste event, provide a chance to change paste content
     */
    PluginEventType[PluginEventType["BeforePaste"] = 9] = "BeforePaste";
    /**
     * Let plugin know editor is ready now
     */
    PluginEventType[PluginEventType["EditorReady"] = 10] = "EditorReady";
    /**
     * Let plugin know editor is about to dispose
     */
    PluginEventType[PluginEventType["BeforeDispose"] = 11] = "BeforeDispose";
    /**
     * HTML Input / TextInput event
     */
    PluginEventType[PluginEventType["Input"] = 12] = "Input";
    /**
     * Pending format state (bold, italic, underline, ... with collapsed selection) is changed
     */
    PluginEventType[PluginEventType["PendingFormatStateChanged"] = 13] = "PendingFormatStateChanged";
    /**
     * Dark mode state is changed
     */
    PluginEventType[PluginEventType["DarkModeChanged"] = 14] = "DarkModeChanged";
    /**
     * Scroll event triggered by scroll container
     */
    PluginEventType[PluginEventType["Scroll"] = 15] = "Scroll";
    /**
     * Operating on an entity. See enum EntityOperation for more details about each operation
     */
    PluginEventType[PluginEventType["EntityOperation"] = 16] = "EntityOperation";
})(PluginEventType = exports.PluginEventType || (exports.PluginEventType = {}));
//# sourceMappingURL=PluginEventType.js.map